import React from 'react';

/**
 * Small circular avatar showing the user's initial. Deterministic hash → colour
 * so the same name always gets the same swatch (helps scanning a long list).
 *
 * No external network call — purely CSS. Drop in next to a name to make
 * uploader / creator columns scannable.
 */
const PALETTE = [
  'bg-teal-100 text-teal-700',
  'bg-violet-100 text-violet-700',
  'bg-amber-100 text-amber-700',
  'bg-emerald-100 text-emerald-700',
  'bg-rose-100 text-rose-700',
  'bg-sky-100 text-sky-700',
  'bg-fuchsia-100 text-fuchsia-700',
  'bg-orange-100 text-orange-700',
];

const colourFor = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length];
};

const sizeClasses = {
  xs: 'w-5 h-5 text-[10px]',
  sm: 'w-6 h-6 text-[11px]',
  md: 'w-7 h-7 text-xs',
};

const UserAvatar = ({ name, size = 'sm', className = '' }) => {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
  const colour = colourFor(name || '');
  const sz = sizeClasses[size] || sizeClasses.sm;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold flex-shrink-0 ${sz} ${colour} ${className}`}
      title={name || ''}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
};

export default UserAvatar;
